import moment from "moment";
import {
  Badge,
  OverflowMenuDropDown,
  OverflowMenuDropDownItem,
} from "../../components";

import { IViewProduct } from "../../interfaces-and-types";
import {
  formatAsCurrency,
  getProductStatusIndicator,
  truncateStringWithEllipsis,
} from "../../utils";

import imagePlaceholder from "../../assets/icons/img-placeholder.svg";
import { productStatus } from "../../enums";

export const productsDisplayFormatter = (item: IViewProduct) => {
  const statusIndicator = getProductStatusIndicator(item);

  return {
    ...item,
    product_icon: (
      <img
        src={item.product_icon || imagePlaceholder}
        alt="product icon"
        className="swapp-product-icon"
      />
    ),
    description: (
      <span title={item.product_description}>
        {truncateStringWithEllipsis(item.product_description, 15)}
      </span>
    ),
    payout_tag: (
      <span title={item?.payout_tag || ""}>
        {truncateStringWithEllipsis(item?.payout_tag, 15)}
      </span>
    ),
    price: (
      <strong>
        {item.currency} {formatAsCurrency(item.price)}
      </strong>
    ),
    status: (
      <Badge
        text={statusIndicator.statusText}
        statusColor={statusIndicator.statusType}
      />
    ),
    product: <strong>{item.product_name}</strong>,
    created_at: (
      <span className="date--oneline">
        {moment(item.created_at).format("MMM DD, YYYY, hh:mm A")}
      </span>
    ),
    edited_at: (
      <span className="date--oneline">
        {!item.edited_at
          ? "-"
          : moment(item.edited_at).format("MMM DD, YYYY, hh:mm A")}
      </span>
    ),
    more: (
      <OverflowMenuDropDown
        focusTrap={false}
        data-floating-menu-container
        size="sm"
        flipped
      >
        <OverflowMenuDropDownItem
          index={1}
          itemText="Edit"
          onClick={item.openEditModal}
        />
        <OverflowMenuDropDownItem
          index={2}
          itemText={
            item.status === productStatus.active ? "Archive" : "Restore"
          }
          onClick={item.archiveProduct}
          hasDivider
        />
        {item.is_delete_locked ? null : (
          <OverflowMenuDropDownItem
            index={3}
            hasDivider={item.status === productStatus.disabled}
            isDelete
            itemText="Delete"
            onClick={item.openDeleteModal}
          />
        )}
      </OverflowMenuDropDown>
    ),
  };
};
